import {postLixilCalendar, postLixilGetSalesRep} from "../api/lixil-api";
import {defaultTimeValue} from "./appointmentReducer";
import {getLixilCampaignInfo, LIXIL_PRODUCT_TYPES} from "../lixilLogic/lixilActions";

export const SET_APPOINTMENT_DATE = "SET_APPOINTMENT_DATE";
export const SET_APPOINTMENT_TIME = "SET_APPOINTMENT_TIME";
export const SET_APPOINTMENT_TIME_STEP_ACTIVE = "SET_APPOINTMENT_TIME_STEP_ACTIVE";
export const SET_AVAILABLE_APPOINTMENTS = "SET_AVAILABLE_APPOINTMENTS";
export const SET_APPOINTMENTS_NOT_AVAILABLE = "SET_APPOINTMENTS_NOT_AVAILABLE";
export const SET_SALES_REP_ID = "SET_SALES_REP_ID";
export const setAppointmentDate = (date) => ({
  type: SET_APPOINTMENT_DATE,
  payload: date
});

export const setAppointmentTime = (time = "", timeSlot = "") => ({
  type: SET_APPOINTMENT_TIME,
  payload: {time, timeSlot}
});

export const setAppointmentTimeStepActive = (timeStepIsActive) => ({
  type: SET_APPOINTMENT_TIME_STEP_ACTIVE,
  payload: timeStepIsActive
});

export const setAvailableAppointments = (availableAppointmentDates) => {
  return (dispatch, getState) => {
    const {appointmentDate, appointmentTimeSlot} = getState().appointmentState;
    let payload = {
      availableAppointmentDates
    };
    if (appointmentDate) {
      const formattedToMatchApiDate = formatCalendarDateToMatchAvailableDate(new Date(appointmentDate));
      const selectedLixilDateObject = availableAppointmentDates.find(dateObject => {
        return dateObject.salesRepAppointmentDate === formattedToMatchApiDate
      });
      if (!selectedLixilDateObject) {
        payload.appointmentDate = "";
        payload.appointmentTimeSlot = defaultTimeValue;
      } else if (!selectedLixilDateObject.salesRepsInSlots.some(timeSlotObject => timeSlotObject.timeSlot === appointmentTimeSlot)) {
        payload.appointmentTimeSlot = defaultTimeValue;
      }
    }
    dispatch({
      type: SET_AVAILABLE_APPOINTMENTS,
      payload
    });
  }
};

export const setAppointmentsNotAvailable = (appointmentsNotAvailable) => ({
  type: SET_APPOINTMENTS_NOT_AVAILABLE,
  payload: {appointmentsNotAvailable}
});

export const setSalesRepId = (salesRepID) => ({
  type: SET_SALES_REP_ID,
  payload: {salesRepID}
});

const getCommonLixilPostData = (store) => {
  const {userState, wizardState} = store;
  const {userInfo, userLocation} = userState;

  const productId = wizardState.wizardSelectedValues
  && wizardState.wizardSelectedValues[1]
  && wizardState.wizardSelectedValues[1].selectedFeature
    ? wizardState.wizardSelectedValues[1].selectedFeature.id
    : 1;

  const productName = getLixilCampaignInfo(store).Product === LIXIL_PRODUCT_TYPES.srBathing
    ? LIXIL_PRODUCT_TYPES.srBathing
    : "BR";

  return {
    contactData: {
      email: userInfo.email,
      firstName: userInfo.firstName,
      installationAddress: userInfo.address,
      lastName: userInfo.lastName,
      phone: userInfo.phone,
      zipcode: userLocation.postal || userInfo.postal,
      "city": userLocation.city,
      "direction": userLocation.direction,
      "state": userLocation.state,
      "streetName": userLocation.streetName,
      "streetNumber": userLocation.streetNumber,
    },
    productInfo: {
      productId,
      productName,
    }
  }
}

  export const checkLixilCalendar = () => {
    return async (dispatch, getState) => {

      const postCalendarData = getCommonLixilPostData(getState());

      // 1) register user
      const postCalendarResponse = await postLixilCalendar(postCalendarData);
      console.log("postCalendarResponse", postCalendarResponse);

      if (postCalendarResponse && postCalendarResponse.data && postCalendarResponse.data.salesRepAvailability) {
        // dispatch(setAppointmentsNotAvailable(false)); // faraday reponse not available for this address
        // removed, it should be set when user submitted the form, if they opened calendar and left - it should be noAppt
        dispatch(setAvailableAppointments(postCalendarResponse.data.salesRepAvailability.availableSalesReps));
        return true
      }

      // dispatch(setAvailableAppointments([
      // {
      //   "salesRepAppointmentDate": "2024-03-18",
      //   "salesRepsInSlots": [
      //   {
      //     "slotEndTime": "string",
      //     "slotStartTime": "string",
      //     "timeSlot": "string"
      //   }
      //  ]
      // }
      // ]));

      // return !(postCalendarResponse && postCalendarResponse.data && postCalendarResponse.data.salesRepAvailability)
      return false
    }
  }

export const getLixilSalesRep = () => {
  return async (dispatch, getState) => {

    const store = getState();
    const {appointmentState} = store;

    let postData = getCommonLixilPostData(store);

    postData.date = formatCalendarDateToMatchAvailableDate(appointmentState.appointmentDate);
    // postData.consultationTime = appointmentState.appointmentTime;
    // postData.timeSlotId = 1;
    postData.timeSlot = appointmentState.appointmentTimeSlot;

    // 1) register user
    const postSalesRepResponse = await postLixilGetSalesRep(postData);
    console.log("postSalesRepResponse", postSalesRepResponse);

    if (postSalesRepResponse && postSalesRepResponse.data && postSalesRepResponse.data.salesRepID) {
      dispatch(setSalesRepId(postSalesRepResponse.data.salesRepID));
    }

    // return !(postCalendarResponse && postCalendarResponse.data && postCalendarResponse.data.salesRepAvailability)
    return false
  }
}

export const formatCalendarDateToMatchAvailableDate = (calendarDate, withSlashes = false) => {

  let day = ""+calendarDate.getDate();
  let month = ""+(calendarDate.getMonth() + 1); // +1 because getMonth returns starting from 0 (January is 0)
  let year = ""+calendarDate.getFullYear();

  day = day.length === 1 ? "0" + day : day;
  month = month.length === 1 ? "0" + month : month;

  if (withSlashes) {
    return month + "/" + day + "/" + year
  }

  return year + "-" + month + "-" + day
}

export const getSelectedLixilDateObject = (appDate, availableAppointmentDates) => {
  const formattedToMatchApiDate = formatCalendarDateToMatchAvailableDate(appDate);
  const selectedLixilDateObject = availableAppointmentDates.find(dateObject => {
    return dateObject.salesRepAppointmentDate === formattedToMatchApiDate
  });
  if (!selectedLixilDateObject) {
    console.log("no selected day? try better search, something is incorrect", );
    return null
  }
  return selectedLixilDateObject
}
